import React from 'react';
import { NewUrlInputModal, BUTTON_SIZE } from 'wix-rich-content-ui-components';

const MediaURLInputModal = ({
  t,
  languageDir,
  helpers,
  isMobile,
  url,
  submittedInvalidUrl,
  setUrl,
  withMobileHeader = false,
  onConfirm,
  dataHook,
  title,
  subTitle,
  saveLabel,
  onDoubleClick
}) => {
  return /* @__PURE__ */ React.createElement(
    NewUrlInputModal,
    {
      onConfirm,
      helpers,
      input: url,
      t,
      languageDir,
      title,
      subTitle,
      submittedInvalidUrl,
      dataHook,
      saveLabel,
      onInputChange: (url2) => setUrl(url2),
      errorMessage: t("SoundCloudUploadModal_Input_InvalidUrl"),
      placeholder: t("EmbedURL_Placeholder"),
      onCloseRequested: helpers.closeModal,
      buttonSize: BUTTON_SIZE.medium,
      isMobile,
      withMobileHeader,
      onDoubleClick,
      withMobileSaveButton: true
    }
  );
};

export { MediaURLInputModal as default };
//# sourceMappingURL=NewMediaUrlInputModal.js.map
